module.exports = __webpack_public_path__ + "videos/simple-interface.67008c1.mp4";